import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getProfileAction } from "../../../store/actions/user.actions";
import {
  createOrder,
  fetchServiceById,
  fetchStyles,
} from "../../../store/slices/servicesSlice";
import { useNavigate, useParams } from "react-router-dom";
import formValidation from "../../../utils/validations";
import { showToast } from "../../../store/slices/toastSlice";
import { showFormErrors } from "../../../utils/commonFunctions";

export default function OrderContainer() {
  const dispatch = useDispatch([]);
  const navigate = useNavigate();
  const fileUploadRef = useRef(null);
  const basicFileUploadRef = useRef(null);
  const { id } = useParams();
  const { profile } = useSelector((state) => state.user);
  const { serviceDetails } = useSelector((state) => state.service);
  let { isLoading } = useSelector((state) => state.loader);

  let { furnishingStyles } = useSelector((state) => state.service);
  const ignoreFields = [];

  const [data, setData] = useState({
    personalInfo: {},
    projectName: "",
    style: "",
    images: [],
    totalPrice: "",
    agreeToTermsAndConditions: false,
  });

  const [hoveredStyle, setHoveredStyle] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const roomList = [
    "Living Room",
    "Lounge/Dining/Kitchen",
    "Lounge/Dining",
    "Lounge",
    "Family Room",
    "Dining/Kitchen",
    "Dining",
    "Kitchen",
    "Primary/Master Bedroom",
    "Bedroom 1",
    "Bedroom 2",
    "Bedroom 3",
    "Bedroom 4",
    "Study",
    "Outdoor Living",
    "Bathroom/Ensuite",
    "Rumpus Room",
    "Games Area",
    "Media Room",
    "Single Room Studio or Unit",
    "Nursery",
    "Kids room",
    "Other - Please specify in additional information below",
  ];

  useEffect(() => {
    dispatch(getProfileAction());
    dispatch(fetchServiceById(id));
    dispatch(fetchStyles());
  }, [dispatch, id]);

  const calculateTotalPrice = () => {
    const images = data?.images || [];
    const total = images.reduce((sum, room) => {
      const itemsTotal = room.items?.reduce((subSum, item) => subSum + item.price, 0) || 0;
      const additionalServicesTotal = room.additionalServices?.reduce((subSum, service) => subSum + service.price, 0) || 0;
      return sum + itemsTotal + additionalServicesTotal + serviceDetails?.price; // Add 51 per room
    }, 0);
    setTotalPrice(total);
  };

  // const calculateTotalPrice = () => {
  //   const images = data?.images || [];
  //   const total = images.reduce((sum, room) => {
  //     const itemsTotal = room.items?.reduce((subSum, item) => subSum + Number(item.price || 0), 0);
  //     const additionalServicesTotal = room.additionalServices?.reduce(
  //       (subSum, service) => subSum + Number(service.price || 0),
  //       0
  //     );

  //     const servicePrice = Number(serviceDetails?.price || 0);

  //     return sum + itemsTotal + additionalServicesTotal + servicePrice;
  //   }, 0);

  //   const finalTotal = isNaN(total) ? 0 : total;
  //   setTotalPrice(finalTotal);
  // };

  const handleChange = ({ name, value, formArrayName, index }) => {
    if (formArrayName) {
      const _newData = { ...data };
      let obj = _newData[formArrayName][index];
      obj[name] = value;
      const formErrors = formValidation(name, value, obj, ignoreFields);
      obj.formErrors = formErrors;
      _newData[formArrayName][index] = obj;
      setData(() => ({
        ..._newData,
      }));
    } else {
      const formErrors = formValidation(name, value, data);
      setData((prev) => ({ ...prev, [name]: value, formErrors }));
    }
  };

  const handleAdditionalServicesChange = ({
    name,
    value,
    formArrayName,
    index,
  }) => {
    const _newData = { ...data };
    let obj = _newData[formArrayName][index];
    if (obj[name]) {
      const findObj = obj[name].find((item) => item.name === value.name);
      if (findObj) {
        obj[name] = obj[name].filter((_) => _ !== findObj);
      } else {
        if (obj[name]) obj[name].push(value);
      }
    } else obj[name] = [value];

    const formErrors = formValidation(name, value, obj, ignoreFields);
    obj.formErrors = formErrors;
    _newData[formArrayName][index] = obj;
    setData(() => ({
      ..._newData,
    }));
  };

  const handleFileUpload = (file) => {
    const images = [...data?.images, { beforeImage: file }];
    const formErrors = formValidation("images", images, data, ignoreFields);
    return setData((prev) => ({
      ...prev,
      images: [...images],
      formErrors,
    }));
  };

  const selectFurninshingStyle = (id) => {
    return setData((prev) => ({ ...prev, style: id }));
  };

  const removeImage = (indexToRemove) => {
    const images = [...data?.images].filter(
      (_, index) => index !== indexToRemove

    );

    if (fileUploadRef.current) {
      fileUploadRef.current.clear();
    }
    if (basicFileUploadRef.current) {
      basicFileUploadRef.current.clear();
    }

    return setData((prev) => ({
      ...prev,
      images: [...images],
    }));
  };

  const onProceedToPay = async (isDraft) => {
    showFormErrors(data, setData, ignoreFields);
    if (
      data?.projectName &&
      data?.style &&
      data?.images &&
      data?.images?.length
    ) {
      if (!data?.agreeToTermsAndConditions) {
        dispatch(
          showToast({
            type: "error",
            message: "Please agree to our Terms and Conditions",
          })
        );
      } else {
        let payload = {
          ...data,
        };

        if (isDraft) {
          payload = {
            ...payload,
            isDraft: true,
            status: "DRAFT",
          };
        }
        dispatch(
          createOrder({
            data: {
              ...payload,
              totalPrice,
              id,
              personalInfo: {
                fullName: profile?.fullName,
                email: profile?.email,
              },
              quantity: data?.images?.length,
            },
            navigate,
          })
        );
      }
    } else {
      dispatch(
        showToast({ type: "error", message: "Please fill all the steps" })
      );
    }
  };

  return {
    data,
    setData,
    isLoading,
    furnishingStyles,
    serviceDetails,
    profile,
    roomList,
    hoveredStyle,
    setHoveredStyle,
    totalPrice,
    ignoreFields,
    handleChange,
    handleAdditionalServicesChange,
    handleFileUpload,
    selectFurninshingStyle,
    calculateTotalPrice,
    onProceedToPay,
    activeIndex,
    setActiveIndex,
    removeImage,
    fileUploadRef,
    basicFileUploadRef
  };
}
